/* ============================================================
   CART DRAWER CONFETTI — Drop this in your theme JS / snippet
   ============================================================
   HOW TO USE:
   Call  triggerCartConfetti()  whenever your cart drawer opens.
   e.g. inside your "Add to Cart" success handler or the function
   that opens the drawer.
   ============================================================ */

(function () {
  /* ── CONFIG ─────────────────────────────────────────────── */
  const CONFIG = {
    particleCount : 120,   // total pieces
    duration      : 3000,  // ms before canvas is removed
    spread        : 90,    // horizontal spread angle (degrees)
    colors: [
      '#FF4081','#FF9800','#FFEB3B','#4CAF50',
      '#2196F3','#9C27B0','#00BCD4','#FF5722',
      '#E91E63','#8BC34A',
    ],
    shapes: ['square', 'rectangle', 'circle'],
  };

  /* ── HELPERS ─────────────────────────────────────────────── */
  function rand(min, max) { return Math.random() * (max - min) + min; }
  function pick(arr)       { return arr[Math.floor(Math.random() * arr.length)]; }

  /* ── PARTICLE CLASS ─────────────────────────────────────── */
  class Particle {
    constructor(canvas) {
      const cx = canvas.width / 2;
      const angleRad = (rand(-CONFIG.spread, CONFIG.spread) - 90) * Math.PI / 180;
      const speed    = rand(4, 11);

      this.x     = rand(cx * 0.2, cx * 1.8);
      this.y     = rand(-20, -5);
      this.vx    = Math.cos(angleRad) * speed;
      this.vy    = Math.sin(angleRad) * speed;
      this.w     = rand(7, 14);
      this.h     = rand(4, 10);
      this.color = pick(CONFIG.colors);
      this.shape = pick(CONFIG.shapes);
      this.rot   = rand(0, Math.PI * 2);
      this.rotV  = rand(-0.15, 0.15);
      this.alpha = 1;
      this.gravity = 0.25;
      this.drag    = 0.98;
    }

    update() {
      this.vy  += this.gravity;
      this.vx  *= this.drag;
      this.x   += this.vx;
      this.y   += this.vy;
      this.rot += this.rotV;
      // fade out near bottom
      if (this.y > window.innerHeight * 0.7) {
        this.alpha -= 0.02;
      }
    }

    draw(ctx) {
      ctx.save();
      ctx.globalAlpha = Math.max(this.alpha, 0);
      ctx.translate(this.x, this.y);
      ctx.rotate(this.rot);
      ctx.fillStyle = this.color;

      if (this.shape === 'circle') {
        ctx.beginPath();
        ctx.arc(0, 0, this.w / 2, 0, Math.PI * 2);
        ctx.fill();
      } else if (this.shape === 'rectangle') {
        ctx.fillRect(-this.w / 2, -this.h / 2, this.w, this.h / 2);
      } else {
        ctx.fillRect(-this.w / 2, -this.w / 2, this.w, this.w);
      }
      ctx.restore();
    }
  }

  /* ── MAIN FUNCTION ──────────────────────────────────────── */
  window.triggerCartConfetti = function () {
    // Avoid stacking multiple canvases
    const existing = document.getElementById('cart-confetti-canvas');
    if (existing) existing.remove();

    const canvas = document.createElement('canvas');
    canvas.id = 'cart-confetti-canvas';

    Object.assign(canvas.style, {
      position      : 'fixed',
      top           : '0',
      left          : '0',
      width         : '100%',
      height        : '100%',
      pointerEvents : 'none',   // clicks pass through
      zIndex        : '999999',
    });

    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    const ctx        = canvas.getContext('2d');
    const particles  = Array.from({ length: CONFIG.particleCount }, () => new Particle(canvas));
    let   rafId      = null;
    const startTime  = performance.now();

    function loop(now) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => { p.update(); p.draw(ctx); });

      if (now - startTime < CONFIG.duration) {
        rafId = requestAnimationFrame(loop);
      } else {
        cancelAnimationFrame(rafId);
        canvas.remove();
      }
    }
    rafId = requestAnimationFrame(loop);
  };

  /* ── AUTO-HOOK: common Shopify cart-drawer open patterns ── */
  /*
   * Strategy 1 – MutationObserver watches for the drawer becoming visible.
   * Adjust the selector to match YOUR theme's cart drawer element.
   *
   * Common selectors:
   *   Dawn          : 'cart-drawer'  (custom element, attr open)
   *   Impulse/Flex  : '#CartDrawer', '#cart-drawer'
   *   Prestige      : '.cart-drawer'
   *   Turbo         : '#cart'
   */
  function setupObserver() {
    const DRAWER_SELECTOR = 'cart-drawer, #CartDrawer, #cart-drawer, .cart-drawer, [id*="cart"][class*="drawer"]';

    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) {
      // Retry once DOM is fully ready
      if (document.readyState !== 'complete') {
        window.addEventListener('load', setupObserver, { once: true });
      }
      return;
    }

    let wasOpen = false;

    const observer = new MutationObserver(() => {
      // Detect "open" state — covers attribute `open`, class `is-open` / `active` / `open`
      const isOpen =
        drawer.hasAttribute('open') ||
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('active') ||
        drawer.classList.contains('open') ||
        drawer.getAttribute('aria-hidden') === 'false';

      if (isOpen && !wasOpen) {
        triggerCartConfetti();
      }
      wasOpen = isOpen;
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }

  /*
   * Strategy 2 – If your theme dispatches a custom event, hook into it:
   *
   * document.addEventListener('cart:open',  triggerCartConfetti);
   * document.addEventListener('drawer:open', triggerCartConfetti);
   */

})();